import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="participant-start-time"
export default class extends Controller {
  connect() {
  }

  update() {
    const localStartTime = document.querySelector('#appointment_local_start_time').value;
    const localTimeZone = document.querySelector('#appointment_local_time_zone').value;
    const pptTimeZone = document.querySelector('#appointment_ppt_time_zone').value;
    // send a GET request to the participant_start_time action with the local start time and time zones as query parameters
    fetch(`/participant_start_time?local_start_time=${encodeURIComponent(localStartTime)}&local_time_zone=${encodeURIComponent(localTimeZone)}&ppt_time_zone=${encodeURIComponent(pptTimeZone)}`, {
      method: 'GET',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error(error));
  }
}
